__turbopack_context__.v({
  "FB": "socia-media-module__paEZuG__FB",
  "INS": "socia-media-module__paEZuG__INS",
  "SocialMediaContent": "socia-media-module__paEZuG__SocialMediaContent",
  "TW": "socia-media-module__paEZuG__TW",
  "YT": "socia-media-module__paEZuG__YT",
});
